<template lang="html">
  <tr>
    <td class="column-id">
    </td>

    <td class="column-name" >
      {{ model.amount}}
    </td>

    <td class="column-date">
      {{ createdAt  }}
    </td>


  </tr>
</template>

<script>
  import Moment from 'moment'

  import { STORE_PREFIX } from '../constants.js';

  export default {
    name: 'refill-row',

    props: {
      companyId: null,
      model: Object,
      is_japan_locale: Boolean
    },

    methods: {

      fetch_list () {
        this.$store.dispatch(STORE_PREFIX + 'admin/vacancies/fetch', {company_id: this.companyId})
      },

      auth () {
        if (!this.user) {
          throw Error
        }

        this.$store.dispatch(STORE_PREFIX + 'admin/authUser', this.user)
          // .then(() => this.$router.replace('/'))
          .then(() => { window.location = '/' })
      },

    },

    computed: {
      createdAt () {
        return this.model.created_at
          ? Moment(this.model.created_at).format(this.dateFormat)
          : null
      },

      dateFormat() {
        return this.is_japan_locale ? 'YYYY.MM.DD' : 'DD.MM.YYYY';
      }
    }
  }
</script>

<style lang="scss" scoped>

  @import "../../../../../styles/colors.scss";

  tr {
    height: 60px;
  }

  .column-date {
    color: $grey-color;
  }
</style>
